export default function toCSSUnit(value: string | number | undefined, unit = 'px'): string | undefined {
    if (value === undefined) {
        return undefined
    }

    if (Number.isInteger(value)) {
        return `${value}${unit}`
    }

    return value as string
}
